import React, { useContext, useEffect, useState } from "react";
import { Col } from "antd";
import CustomList from "../components/List";
import ListItem from "../components/ListItem";
import API from "../../API";
import { Link } from "react-router-dom";
import "./styles.css";
import { useProcuringEntity } from "../../hooks/useProcuringEntity";
import { AppContext } from "../../context/AppContext";

const packageSpan = {
  xxl: 4,
  xl: 4,
  lg: 4,
  md: 6,
  sm: 9,
  xs: 9,
};

// const subProjects = {
//   xxl: 4,
//   xl: 4,
//   lg: 4,
//   md: 8,
//   sm: 8,
//   xs: 8,
// };

const actualPhysicalProgress = {
  xxl: 5,
  xl: 5,
  lg: 5,
  md: 8,
  sm: 10,
  xs: 10,
};

const plannedPyscalProgress = {
  xxl: 6,
  xl: 6,
  lg: 6,
  md: 0,
  sm: 0,
  xs: 0,
};

const timeElapsed = {
  xxl: 0,
  xl: 0,
  lg: 0,
  md: 0,
  sm: 0,
  xs: 0,
};

const plannedFinancialProgress = {
  xxl: 5,
  xl: 5,
  lg: 5,
  md: 8,
  sm: 8,
  xs: 0,
};

const actualFinancialProgress = {
  xxl: 6,
  xl: 6,
  lg: 6,
  md: 7,
  sm: 8,
  xs: 8,
};

// Header layout with responsive classes
const headerLayout = [
  {
    ...packageSpan,
    header: "Package",
    className: "", // Always visible
  },
  // {
  //   ...subProjects,
  //   header: "Sub-projects",
  //   className: "", // Always visible
  // },
  {
    ...plannedPyscalProgress,
    header: "Planned Physical Progress(%)",
  },
  {
    ...actualPhysicalProgress,
    header: "Actual Physical Progress(%)",
    className: "", // Always visible
  },
  // {
  //   ...plannedFinancialProgress,
  //   header: "Planned Financial Progress(%)",
  // },
  {
    ...actualFinancialProgress,
    header: "Actual Financial Progress(%)",
  },
  // {
  //   ...timeElapsed,
  //   header: "Time elapsed(%)",
  // },
];

const PackagesList = ({ match }) => {
  const { selectedReportID, selectedReportDetails, selectedProcuringEntity } =
    useContext(AppContext);
  // Single source of truth: procuring entity id comes from the selected report
  const procuringEntityId =
    selectedReportDetails?.procuring_entity_id ??
    selectedProcuringEntity ??
    null;
  const {
    council,
    loading: procuringEntityLoading,
    error,
  } = useProcuringEntity(procuringEntityId);
  console.log({ council, procuringEntityLoading, error });

  const [packData, setPackData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [procuringEntityData, setProcuringEntityData] = useState(null);

  const capitalizeWords = (str) => {
    return str
      ?.toLowerCase()
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");
  };

  // calculate time elapsed in months
  const getTimeElapsed = (startDate, endDate) => {
    let start = new Date(startDate);
    let end = new Date(endDate);
    let months =
      (end.getFullYear() - start.getFullYear()) * 12 +
      end.getMonth() -
      start.getMonth();
    return months; // returns the number of months
  };

  const getPackagesData = () => {
    setIsLoading(true);
    if (!selectedReportID || !procuringEntityId) {
      setIsLoading(false);
      return;
    }
    Promise.all([
      API.getPackages({ "filter[procuring_entity_id]": procuringEntityId }),
      API.getProcuringEntity(procuringEntityId),
    ])
      .then((res) => {
        setPackData(res?.length > 0 ? res[0].data.data : []);
        setProcuringEntityData(res?.length > 0 ? res[1].data : null);
      })
      .catch((err) => {
        console.error("Failed to fetch packages data:", err);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getPackagesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReportID, procuringEntityId]);

  // refresh handled via getPackagesData + effect

  const handlePaginate = (page) => {
    setCurrentPage(page);
    // If you need to fetch data for the new page, call your API here
    // getPackagesData(page);
  };

  // history available if navigation for package drilldowns is reintroduced
  return (
    <>
      {procuringEntityLoading && (
        <div style={{ padding: 24, textAlign: "center" }}>
          Loading procuring entity data...
        </div>
      )}

      {error && (
        <div style={{ padding: 24, color: "red" }}>
          Error loading procuring entity: {error.message}
        </div>
      )}

      {!selectedReportID && !procuringEntityLoading && (
        <div style={{ padding: 24 }}>
          Please select a report to view packages.
        </div>
      )}

      {/* page content */}

      <div
        className="prst-table"
        style={
          !procuringEntityId || procuringEntityLoading
            ? { opacity: 0.4, pointerEvents: "none" }
            : { padding: "16px" }
        }
      >
        <CustomList
          itemName="Packages"
          items={packData}
          page={currentPage}
          itemCount={packData?.length ?? 0}
          actionButtonProp={{
            title: procuringEntityData
              ? `${capitalizeWords(
                  packData?.length > 0
                    ? packData[0]?.procuring_entity?.council?.name
                    : ""
                )} Packages`
              : "Packages",
            // buttons: (),
          }}
          loading={isLoading}
          headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id}
              name={item?.name}
              item={item}
              renderActions={() => false}
              isPackage={false}
            >
              {/* eslint-disable react/jsx-props-no-spreading */}
              <Col
                {...packageSpan}
                data-label="Package"
                className="contentEllipse"
              >
                <Link to={{ pathname: `${match.url}/${item.id}` }}>
                  {item?.name}
                </Link>
              </Col>
              {/* <Col {...subProjects}>
                {item.sub_projects_count ? item.sub_projects_count : 0}
              </Col> */}
              <Col
                {...plannedPyscalProgress}
                data-label="Planned Physcal Progress"
                className="contentEllipse"
              >
                {item?.progress?.planned_physical_progress || "-"}
              </Col>

              <Col
                {...actualPhysicalProgress}
                className="contentEllipse"
                data-label="Actual Physical Progress"
              >
                {item?.progress?.actual_physical_progress || "-"}
              </Col>
              {/* <Col
                {...plannedFinancialProgress}
                data-label="Planned Financial Progress"
                className="contentEllipse"
              >
                {item?.progress?.planned_financial_progress_percent ? `${item.progress.planned_financial_progress_percent}%` : "-"}
              </Col> */}
              <Col
                {...actualFinancialProgress}
                data-label="Actual Financial Progress"
                className="contentEllipse"
              >
                {item?.progress?.actual_financial_progress_percent
                  ? `${item.progress.actual_financial_progress_percent}`
                  : "-"}
              </Col>
              {/* <Col
                {...timeElapsed}
                className="contentEllipse"
              >
                {getTimeElapsedPercentage(
                  item?.contract?.date_of_commencement_of_works,
                  item?.contract?.date_of_contract_completion
                )}
              </Col> */}
              <Link
                to={{ pathname: `${match.url}/${item.id}` }}
                className="view-card-details"
              >
                <button>View Details</button>
              </Link>
            </ListItem>
          )}
          onPaginate={handlePaginate}
          paginationPosition="bottom"
        />

        {/* Bottom controls placeholder */}
      </div>
    </>
  );
};

export default PackagesList;
